import {pnc_url_pnc} from '../config/constants';
import axios from 'axios';

class UserAPI{
  static getUserInfo(popkey) {

    return axios.get(pnc_url_pnc + '/user',{
    headers: {
         'Content-Type': 'application/json',
         'Authorization': '555',
         'User-Key': popkey,
       },
      params:{

      }
    }
    );
  }

  static goConnect(email,pwd) {
    return axios.post(pnc_url_pnc + '/auth/email',{
      headers: {
        "Authorization":'555',
        'Content-Type' : 'application/json',
        "User-Key": null
      },
      credentials: {
        email:email,
        pwd:pwd
        }
      }
    );
  }

  static registerUser(firstName,lastName,pseudo,email,avatar,password){
    return axios.post(pnc_url_pnc + '/signup/email',{
      headers: {
        "Authorization":'555',
        'Content-Type' : 'application/json',
        "User-Key": null
      },
      user: {
        firstname:firstName,
        name:lastName,
        avatar:avatar,
        pseudo:pseudo,
        email:email,
        pwd_for_confirmation:password,
        pwd:password,
        }
      }
    );

  }

  static updatePersonnalData(firstname,name,pseudo,popkey){
      return axios.post(pnc_url_pnc + '/user/updatepersodata',{
        headers: {
          "Authorization":'555',
          'Content-Type' : 'application/json',
          "User-Key": popkey
        },
        popkey:popkey,
          user:{
            firstname:firstname,
            name:name,
            pseudo:pseudo
          }
      }
    )
  }

  static updateAvatarUser(popkey,avatar){
      return axios.post(pnc_url_pnc + '/user/updateavatar',{
        headers: {
          "Authorization":'555',
          'Content-Type' : 'application/json',
          "User-Key": popkey
        },
        popkey:popkey,
          user:{
            avatar:avatar
          }
      }
    )
  }

  static updateBoatUser(popkey,immat,name,id_boat){
      return axios.post(pnc_url_pnc + '/user/updateboatuser',{
        headers: {
          "Authorization":'555',
          'Content-Type' : 'application/json',
          "User-Key": popkey
        },
        popkey:popkey,
          user:{
            boat_immatriculation:immat,
            boat_name:name,
            id_boat:id_boat
          }
      }
    )
  }

  static updatePassworduser(popkey,pwd,pwd_for_confirmation){
      return axios.post(pnc_url_pnc + '/user/updatepassworduser',{
        headers: {
          "Authorization":'555',
          'Content-Type' : 'application/json',
          "User-Key": popkey
        },
        popkey:popkey,
          user:{
            pwd:pwd,
            pwd_for_confirmation:pwd_for_confirmation,

          }
      }
    )
  }


  static updateAdress(popkey,adress){
      return axios.post(pnc_url_pnc + '/user/updateadressuser',{
        headers: {
          "Authorization":'555',
          'Content-Type' : 'application/json',
          "User-Key": popkey
        },
        popkey:popkey,
          user:{
              adress:adress

          }
      }
    )
  }


  static sendInformationLocation(popkey,boat_immatriculation,boat_name,date,time,port){
      return axios.post(pnc_url_pnc + '/user/postlocationboat',{
        headers: {
          "Authorization":'555',
          'Content-Type' : 'application/json',
          "User-Key": popkey
        },
        popkey:popkey,
          location:{
            boat_immatriculation:boat_immatriculation,
            boat_name:boat_name,
            date:date,
            time:time,
            port:port

          }
      }
    )
  }

  static sendEmail(email){

    return axios.get(pnc_url_pnc + '/user/forgotpwd',{
      headers:{
        "Authorization":'555',
        'Content-Type' : 'application/json',

      },
      params:{
        email:email
      }
    })
  }


}


export default UserAPI;
